import { Component, Input, OnInit, TemplateRef } from '@angular/core';

/**
 * Generic menu component for the application. It uses Angular Material Menu internally,
 * so the user only needs to pass the menu items to the contents.
 */
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  @Input() public title: string;

  @Input() public customTitle: TemplateRef<{a: number;}> | null = null;

  /**
   * Small label to be displayed on the top left side of the menu
   */
  @Input() public label: string;

  /**
   * Suffix material icon name. Defaults to "arrow_drop_down"
   */
  @Input() public suffix: string = 'arrow_drop_down';

  /**
   * Determine whether the menu is disabled or not
   */
  @Input() public disabled: boolean = false;

  public isMenuOpen = false;

  public constructor() {}

  public ngOnInit(): void {}

  public onMenuOpen() {
    this.isMenuOpen = true;
  }

  public onMenuClose() {
    this.isMenuOpen = false;
  }
}
